// extracted by mini-css-extract-plugin
export default {"form":"PriceBookModal_form__QYGqp"};